import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import InfoIcon from "@icons/myicons/info.svg?react";
import { Tooltip } from "../../Tooltip";

export const ToolTipInfo = ({
  desc1,
  desc2,
  iconSize = 24,
  openOnClick = true,
  openOnHover = false,
  iconColor,
}: {
  desc1: string;
  desc2?: string;
  iconSize?: number;
  openOnClick?: boolean;
  openOnHover?: boolean;
  iconColor?: string;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Tooltip
      openOnClick={openOnClick}
      isHovered={openOnHover && isHovered}
      text={
        <>
          <Typography
            variant="body3"
            color="text.onTooltipPrimarySub"
            dangerouslySetInnerHTML={{ __html: desc1 }}
          />
          {desc2 && (
            <Typography
              variant="body3"
              color="text.onTooltipPrimarySub"
              dangerouslySetInnerHTML={{ __html: desc2 }}
            />
          )}
        </>
      }
    >
      <Box
        display="flex"
        sx={{ cursor: "help" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <InfoIcon
          width={`${iconSize}px`}
          height={`${iconSize}px`}
          style={{ color: iconColor }}
        />
      </Box>
    </Tooltip>
  );
};
